{
  "page": {
    "title": "Integración",
    "subtitle": "Trae sedes, trabajadores, horarios y ausencias desde el sistema de tu empresa.",
    "connectedTo": "Conectado a {system}",
    "noAccess": "No tienes acceso a la integración.",
    "unavailableTitle": "La integración no está disponible en este servidor",
    "unavailableDescription": "Pide a Fermin que la habilite para tu empresa.",
    "retry": "Reintentar"
  },
  "tabs": {
    "label": "Secciones de la integración",
    "conexion": "Conexión",
    "sincronizar": "Sincronizar",
    "revision": "Revisión",
    "historial": "Historial",
    "countLabel": "{count} pendientes"
  },
  "resources": {
    "SITES": "Sedes",
    "WORKERS": "Trabajadores",
    "SCHEDULES": "Horarios",
    "ABSENCES": "Ausencias y feriados"
  },
  "modes": {
    "INCREMENTAL": "Incremental",
    "FULL": "Completa"
  },
  "recordTypes": {
    "SITE": "Sede",
    "WORKER": "Trabajador",
    "WEEKLY_TEMPLATE": "Plantilla semanal",
    "DATED_SHIFT": "Turno por fecha",
    "ABSENCE": "Ausencia",
    "HOLIDAY": "Feriado"
  },
  "entityTypes": {
    "SITE": "Sede",
    "WORKER": "Trabajador"
  },
  "status": {
    "QUEUED": "En cola",
    "RUNNING": "En curso",
    "AWAITING_CONFIRMATION": "Espera confirmación",
    "COMPLETED": "Completada",
    "COMPLETED_WITH_ERRORS": "Completada con errores",
    "FAILED": "Fallida",
    "DISCARDED": "Descartada"
  },
  "results": {
    "CREATED": "Creado",
    "UPDATED": "Actualizado",
    "UNCHANGED": "Sin cambios",
    "DEACTIVATED": "Desactivado",
    "NEEDS_REVIEW": "Para revisión",
    "SKIPPED": "Omitido",
    "ERROR": "Con error",
    "NOT_REPORTED": "No reportado"
  },
  "proposals": {
    "LINK": "Vincular",
    "CREATE": "Crear",
    "CREATE_PENDING_LOCATION": "Crear (falta ubicación)",
    "REVIEW": "Para revisión",
    "SKIP": "Omitir",
    "ERROR": "Con error"
  },
  "failures": {
    "INVALID_KEY": "La clave del sistema externo no es válida.",
    "FORBIDDEN": "La clave no tiene permiso para leer este dato.",
    "COMPANY_MISMATCH": "La clave corresponde a otra empresa del sistema externo.",
    "RESOURCE_NOT_OFFERED": "Tu sistema no ofrece este dato.",
    "UPSTREAM_UNAVAILABLE": "El sistema externo no respondió. Intenta más tarde.",
    "RATE_LIMITED": "El sistema externo pidió esperar demasiado.",
    "INVALID_RESPONSE": "El sistema externo respondió con un formato inesperado.",
    "INVALID_REQUEST": "El sistema externo rechazó la consulta de Fermin.",
    "URL_REJECTED": "La URL no es válida o apunta a una red interna.",
    "COMPANY_SUSPENDED": "La empresa está suspendida; no se puede sincronizar.",
    "INTERRUPTED": "La sincronización se interrumpió (reinicio del servidor). Vuelve a lanzarla.",
    "INTERNAL": "Ocurrió un error inesperado en Fermin durante la sincronización."
  },
  "messages": {
    "INVALID_RECORD": "El registro no cumple el contrato: {fields}.",
    "SITE_NOT_LINKED": "La sede {site} no está vinculada en Fermin.",
    "WORKER_NOT_LINKED": "El trabajador {worker} no está vinculado en Fermin.",
    "SITE_PENDING_LOCATION": "Falta la ubicación de la sede: complétala en la revisión.",
    "DUPLICATE_DOCUMENT": "El documento ya pertenece a otro trabajador de Fermin.",
    "DUPLICATE_INTERNAL_CODE": "El código interno ya pertenece a otro trabajador de Fermin.",
    "DUPLICATE_SITE_NAME": "Ya existe otra sede con ese nombre en Fermin.",
    "NO_SITES": "El trabajador activo no tiene sedes.",
    "MISSING_PRIMARY_SITE": "Falta la sede principal.",
    "MULTIPLE_PRIMARY_SITES": "Hay más de una sede principal.",
    "SITE_INACTIVE": "La sede {site} está desactivada en Fermin.",
    "WORKER_ANONYMIZED": "El trabajador fue anonimizado en Fermin y no se puede reactivar. Desvincúlalo para crearlo de nuevo.",
    "SHIFT_INCOHERENT_MIDNIGHT": "El turno termina antes de empezar y no indica que cruza medianoche.",
    "SHIFT_TOO_SHORT": "El turno dura menos de 1 hora.",
    "SHIFT_TOO_LONG": "El turno dura 24 horas o más.",
    "TOO_MANY_SHIFTS": "Fermin admite hasta 2 turnos por día.",
    "SHIFTS_OVERLAP": "Los turnos del día se cruzan entre sí o con el día vecino.",
    "WORK_AND_REST_SAME_DAY": "El mismo día tiene turno y descanso.",
    "BREAK_OUT_OF_RANGE": "El refrigerio debe estar entre 0 y 180 min y ser menor que el turno.",
    "TOLERANCE_OUT_OF_RANGE": "La tolerancia debe estar entre 0 y 60 min.",
    "SCHEDULE_CONFLICT": "Se cruza con otra plantilla del mismo trabajador ({other}).",
    "PERIOD_CLOSED": "Toca un período cerrado del tareo; no se aplicó.",
    "ABSENCE_OVERLAP": "Se cruza con una ausencia registrada en Fermin.",
    "ABSENCE_TOO_LONG": "La ausencia supera el máximo de Fermin (366 días, o 31 si es por horas).",
    "ABSENCE_PENDING": "Pendiente de aprobación en el sistema externo.",
    "ABSENCE_NOT_APPROVED": "Rechazada o anulada en el sistema externo.",
    "ABSENCE_TYPE_IGNORED": "Tipo de ausencia configurado para ignorarse.",
    "HOLIDAY_SCOPE_UNSUPPORTED": "Fermin aún no aplica feriados regionales.",
    "HOLIDAY_OTHER_COUNTRY": "Feriado de otro país.",
    "HOLIDAY_INFORMATIVE": "Feriado informativo (laborable).",
    "HOLIDAY_DUPLICATE": "Ya existe un feriado en Fermin ese día.",
    "NOT_LINKED_TOMBSTONE": "Borrado en el origen; no estaba vinculado.",
    "SKIPPED_BY_ADMIN": "Omitido por un administrador.",
    "NOT_REPORTED": "El sistema externo no lo informó en la sincronización completa."
  },
  "warnings": {
    "UNKNOWN_DOCUMENT_TYPE": "Tipo de documento desconocido; se registró como Otro.",
    "UNKNOWN_ABSENCE_TYPE": "Tipo de ausencia desconocido; se registró como Licencia.",
    "FIELD_OWNERSHIP_CHANGED": "Un dato empezó a llegar del sistema externo y reemplazó el valor de Fermin.",
    "NAME_TRUNCATED": "El nombre se recortó al máximo que admite Fermin.",
    "BREAK_WINDOW_IGNORED": "Se ignoró la hora fija del refrigerio; se usan solo sus minutos.",
    "PARTIAL_ABSENCE_AS_PERMISSION": "La ausencia por horas se registró como permiso.",
    "ABSENCE_SITE_IGNORED": "Se ignoró la sede indicada en la ausencia.",
    "TERMINATION_SCHEDULED": "Cese programado: se dará de baja en su fecha.",
    "SITE_NOT_LINKED": "Una sede del trabajador aún no está vinculada en Fermin.",
    "CLOCK_SKEW": "El reloj del sistema externo difiere del de Fermin en más de 2 minutos.",
    "NO_ME_ENDPOINT": "Tu sistema no informa qué datos ofrece: márcalos a mano.",
    "CONTRACT_VERSION_UNKNOWN": "Versión del contrato no reconocida; se usará la última conocida."
  },
  "reasons": {
    "DOCUMENT_NAME_MISMATCH": "Mismo documento, nombres distintos",
    "DOCUMENT_TYPE_MISMATCH": "Mismo número, otro tipo de documento",
    "INTERNAL_CODE_MATCH": "Coincide el código interno",
    "EMAIL_MATCH": "Coincide el correo",
    "MULTIPLE_CANDIDATES": "Varios candidatos posibles",
    "MATCH_AFTER_FIRST_SYNC": "Coincidencia después de la primera sincronización",
    "REHIRE_NEW_ID": "Posible reingreso con otro identificador",
    "MISSING_PHONE": "Falta el teléfono",
    "SITE_NAME_MATCH": "Hay una sede con el mismo nombre",
    "MISSING_LOCATION": "Falta la ubicación"
  },
  "errors": {
    "loadFailed": "No pudimos cargar la integración",
    "runLoadFailed": "No pudimos cargar la sincronización",
    "unknownCompany": "sin nombre"
  },
  "managed": {
    "hint": "Gestionado por {system}",
    "chip": "Integrada"
  },
  "run": {
    "title": "Sincronización de {resource}",
    "back": "Volver a la integración",
    "mode": "Modo",
    "startedBy": "Lanzada por",
    "startedAt": "Inicio",
    "finishedAt": "Fin",
    "confirmedBy": "Confirmada por",
    "confirmedByAt": "{name} · {at}",
    "none": "—",
    "inProgress": "Sincronizando…",
    "duration": {
      "label": "Duración",
      "seconds": "{seconds} s",
      "minutes": "{minutes} min {seconds} s",
      "hours": "{hours} h {minutes} min"
    },
    "countersTitle": "Resultado",
    "noCounters": "Aún no hay registros procesados.",
    "counters": {
      "created": "{count} creados",
      "updated": "{count} actualizados",
      "unchanged": "{count} sin cambios",
      "deactivated": "{count} desactivados",
      "needs_review": "{count} para revisión",
      "skipped": "{count} omitidos",
      "error": "{count} con error",
      "not_reported": "{count} no reportados",
      "days_changed": "{count} días actualizados",
      "days_skipped_closed": "{count} días en períodos cerrados"
    },
    "streamsTitle": "Lectura por tipo de dato",
    "streams": {
      "recordType": "Dato",
      "watermark": "Cambios leídos",
      "pages": "Páginas",
      "records": "Registros",
      "watermarkRange": "{from} → {to}",
      "fromStart": "Desde el inicio"
    },
    "httpStatus": "Respuesta del sistema externo: HTTP {status}",
    "requestId": "Identificador de la consulta:",
    "copy": "Copiar",
    "copied": "Copiado",
    "copyRequestId": "Copiar el identificador de la consulta",
    "preview": {
      "banner": "Revisa antes de aplicar · vence {expires}",
      "bannerNoExpiry": "Revisa antes de aplicar",
      "count": "{label}: {count}",
      "onlyInFermin": "Solo en Fermin: {count}",
      "confirm": "Confirmar y aplicar",
      "discard": "Descartar",
      "discardTitle": "¿Descartar esta vista previa?",
      "discardDescription": "No se aplicará ningún cambio. Podrás sincronizar de nuevo cuando quieras.",
      "confirmed": "Aplicando los cambios…",
      "discarded": "Vista previa descartada"
    }
  }
}
